import React, { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { IconButton, Switch, Tooltip } from '@material-ui/core';

import styles from '../styles.module.css';

const messages = defineMessages({
  TOGGLE_NIGHT_MODE: {
    id: 'TOGGLE_NIGHT_MODE',
    defaultMessage: 'Toggle night mode',
  },
});

function NightModeToggle() {
  const [toggled, setToggled] = useState(false);

  const toggleNightMode = () => {
    setToggled(!toggled);
  };

  return ''; // feature not enabled in v40

  // eslint-disable-next-line no-unreachable
  const nightmodeIconOn = (
    <IconButton>
      <span className="nsicon-m nsicon-m-lights-on" />
    </IconButton>
  );

  const nightmodeIconOff = (
    <IconButton>
      <span className="nsicon-m nsicon-m-lights-off" />
    </IconButton>
  );

  return (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.TOGGLE_NIGHT_MODE} />}>
      <Switch
        checked={toggled}
        onChange={toggleNightMode}
        icon={nightmodeIconOn}
        checkedIcon={nightmodeIconOff}
        classes={{ bar: styles.colorChecked }}
      />
    </Tooltip>
  );
}

export default NightModeToggle;
